export const AMPLITUDE_API_KEY = 'a401f6798fcb07fd565afd12f2f55abd'
export const POSTHOG_API_KEY = 'phc_P89YgP7pp9TbmGnMB2s9G06vhaI0PWD4kBMvHot7OEu'
